import { Snackbar, Alert, Stack } from '@mui/material';
import { useNotificationStore } from '../hooks/useNotify';

export default function NotificationHost() {
  const notifications = useNotificationStore((s) => s.notifications);
  const dismiss = useNotificationStore((s) => s.dismiss);

  return (
    <Stack spacing={1} sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 2000 }}>
      {notifications.map((n) => (
        <Snackbar
          key={n.id}
          open
          autoHideDuration={n.duration || 5000}
          onClose={() => dismiss(n.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ position: 'static' }}
        >
          <Alert onClose={() => dismiss(n.id)} severity={n.severity || 'info'} variant="filled" sx={{ width: '100%' }}>
            {n.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
}
